import { Model, MapTo } from 'src/app/decorators/mapto';

export class StatesAndCitiesModel extends Model {
    @MapTo()
    id: number;
    @MapTo()
    name: string;
    @MapTo()
    country_id: number;
    @MapTo()
    state_id: number;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }
}
